import {
  gray4,
  mainColor,
  mainDark3Color,
  red,
  redLightColor,
} from "assets/styleUtils";
import { cancelInquiryBox, changeInquiryBox } from "data/company";
import { ButtonModal } from "modal";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetcher } from "utils/ApiUtil";
import { IInquiry, UpdateListType } from "./InquiryBoxList";
import styles from "./style.module.css";

type TEtcTime = {
  date: string;
  time?: string;
};

export function InquiryListItem({
  item,
  type,
  extra,
  updateList,
  select,
  checkHandle,
  handleSelectNoAndContructNo,
}: {
  item: IInquiry;
  type: "wedding" | "etc";
  extra?: { category?: string; content: string; title: string }[];
  updateList: ({ no, status, cancel }: UpdateListType) => void;
  select?: IInquiry[];
  checkHandle?: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    item: IInquiry
  ) => void;
  handleSelectNoAndContructNo: (
    selectedNo: number,
    selectedContructNo: number
  ) => void;
}) {
  const navigate = useNavigate();
  const wantWeddingData = (extra || [])
    .filter((item) => item.category === "counselingDate")
    .sort((a, b) => {
      const aRank = parseInt(a.title.replace("순위", ""), 10);
      const bRank = parseInt(b.title.replace("순위", ""), 10);
      return aRank - bRank;
    });

  const [tempStatus, setTempStatus] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const cancelCheckAlert = (status: number) => {
    setTempStatus(status);
    setShowAlert(true);
  };
  const [reservStatus, setReservStatus] = useState(
    !!item.counsel_change_day ? true : false
  );
  const totalChanges =
    (item.log?.cancel_cnt ?? 0) + (item.log?.change_cnt ?? 0);
  const result = totalChanges > 1 ? 0 : 1 - totalChanges;
  const etcShowSchedule = (): TEtcTime => {
    switch (item.category) {
      case "드레스":
        return {
          date: (
            (extra || []).filter((_) => _.category === "counselingDate")[0] ||
            {}
          ).content,
          time: (
            (extra || []).filter((_) => _.category === "counselingTime")[0] ||
            {}
          ).content,
        };
      case "본식스냅":
      case "본식DVD":
      case "연주/사회자/뮤지컬웨딩":
      case "웨딩카":
        return {
          date:
            ((extra || []).filter((_) => _.category === "weddingDate")[0] || {})
              .content || "",
          time: (
            (extra || []).filter((_) => _.category === "weddingTime")[0] || {}
          ).content,
        };
      case "스튜디오/스냅":
      case "제주업체":
        return {
          date:
            (
              (extra || []).filter((_) => _.category === "takePhotoDate")[0] ||
              {}
            ).content || "상세 예약내역을 클릭해주세요",
        };
      case "답례품":
      case "액자/사진보정":
        return {
          date:
            ((extra || []).filter((_) => _.category === "useDate")[0] || {})
              .content || "상세 예약내역을 클릭해주세요",
        };
      case "예복":
      case "예물":
      case "한복":
      case "가전":
      case "홈스타일링":
      case "기타":
        return {
          date:
            (
              (extra || []).filter((_) => _.category === "counselingDate")[0] ||
              {}
            ).content || "상세 예약내역을 클릭해주세요",
        };
      case "플라워":
        return {
          date:
            (
              (extra || []).filter((_) =>
                _.title.includes("본식일자" || "촬영일자")
              )[0] || {}
            ).content || "상세 예약내역을 클릭해주세요",
        };
      default:
        return { date: "상세 예약내역은 클릭해주세요" };
    }
  };

  const statusButton = ({
    status,
    contructor_name,
    counsel_cancel_day,
  }: {
    status: number;
    contructor_name?: string;
    counsel_cancel_day?: string | null;
  }) => {
    if (!counsel_cancel_day) {
      switch (status) {
        case 0:
          return (
            <div
              style={{ backgroundColor: "#FFB33B" }}
              className={styles.statusStyle}
              onClick={() => cancelCheckAlert(0)}
            >
              접수 취소하기
            </div>
          );
        case 1:
          return <></>;
        case 2:
          return (
            <div
              style={{ backgroundColor: mainDark3Color }}
              className={styles.statusStyle}
              onClick={() =>
                navigate(
                  `/SignIn/MyPointList/PointApplyPage?company=${contructor_name}&companyNo=${item.no}&caterogy=${item.category}`
                )
              }
            >
              계약 포인트 신청하기
            </div>
          );
        case 3:
        // return (
        //   <></>
        //   // <div
        //   //   style={{ backgroundColor: redLightColor }}
        //   //   className={styles.statusStyle}
        //   // >
        //   //   되돌리기
        //   // </div>
        // );
        default:
          return <></>;
      }
    }
  };

  const schedule = etcShowSchedule();
  const hasValidCounselDays = item.counsel_days;
  const displayDate = hasValidCounselDays
    ? item.counsel_open_day || item.counsel_days
    : schedule.date;
  const displayTime = hasValidCounselDays
    ? item.counsel_open_time || item.counsel_time
    : schedule.time;
  const displayPoint =
    hasValidCounselDays && item.counsel_open_point
      ? item.counsel_open_point
      : item.counsel_point;

  function cancelApply(no: number) {
    cancelInquiryBox({
      estimate_no: item.estimate_no,
      estimate_sub_no: item.no,
      counsel_cancel_reason: "접수 취소",
    });
    updateList({ no: no, status: 0, cancel: "Y" });
  }

  function checkItemStatus1(
    e: React.MouseEvent<HTMLImageElement, MouseEvent>,
    item: IInquiry
  ) {
    checkHandle?.(e, item);
    handleSelectNoAndContructNo(item.estimate_no, item.contructor_no);
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {showAlert && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.4)",
              zIndex: "200",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setShowAlert(false);
            }}
          ></div>
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "300px",
              height: "200px",
              zIndex: "200",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setShowAlert(false);
            }}
          >
            <ButtonModal
              title={"접수 취소"}
              sub={"정말로 취소하시겠습니까?"}
              oneButton={{
                color: gray4,
                text: "아니요",
                onClick: () => setShowAlert(false),
              }}
              twoRightButton={{
                color: mainColor,
                text: "네",
                onClick: () => {
                  setShowAlert(false);
                  cancelApply(item.no);
                },
              }}
            />
          </div>
        </>
      )}

      <div
        style={{
          display: "flex",
          marginTop: "14px",
          marginBottom: "14px",
        }}
      >
        {type === "wedding" &&
          (item.status === 3 ||
            !!item.counsel_cancel_day ||
            (!!item.counsel_open_day && !!item.counsel_cancel_reason)) && (
            <div className={styles.checkImg}>
              <img
                src={
                  select && select[0]?.no === item.no
                    ? "/images/checkCircle.png"
                    : "/images/uncheckCircle.png"
                }
                onClick={(e) => checkHandle?.(e, item)}
              />
            </div>
          )}
        {item.status === 1 && !item.counsel_cancel_day && (
          <div className={styles.checkImg}>
            <img
              src={
                select && select[0]?.no === item.no
                  ? "/images/checkCircle.png"
                  : "/images/uncheckCircle.png"
              }
              onClick={(e) => checkItemStatus1(e, item)}
            />
          </div>
        )}

        <div
          style={{ display: "flex", cursor: "pointer" }}
          onClick={() =>
            navigate(
              `/SignIn/InquiryBoxList/detail?no=${item.no}&type=${type}&status=${item.status}`
            )
          }
        >
          <img
            src={item.contructor_img || "/images/homeLogo.png"}
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "5px",
            }}
          />
          <div
            style={{
              marginLeft: "10px",
            }}
          >
            <div
              style={{ display: "flex", lineHeight: "180%" }}
              className={styles.mediaBlock}
            >
              <div
                style={{
                  wordBreak: "keep-all",
                }}
                className={styles.mediaContructName}
              >
                {item.contructor_name}
              </div>
              <div
                className={styles.spotMediaMargin}
                style={{ display: "flex" }}
              >
                <div style={{ marginLeft: "10px" }}>
                  {!!item.spot && item.spot.name}
                </div>
                <div style={{ marginLeft: "10px" }}>
                  {!!item.extra_data_title && item.extra_data_title}
                </div>
              </div>
            </div>
            <div>
              {type === "wedding" && (
                <div style={{ display: "flex" }} className={styles.mediaBlock}>
                  {(() => {
                    if (item.status === 3 || !!item.counsel_cancel_day) {
                      if (item.status === 3) {
                        return (
                          <div style={{ color: "navy" }}> 예약 취소 완료</div>
                        );
                      }
                      if (item.status === 0) {
                        return (
                          <div style={{ color: "gray" }}> 접수 취소 완료</div>
                        );
                      } else {
                        return (
                          <div style={{ color: "orange" }}>취소 확인중</div>
                        );
                      }
                    } else if (item.status === 0) {
                      if (item.counsel_open_day && item.counsel_cancel_reason) {
                        return (
                          <div style={{ color: "gray" }}> 접수 취소 완료</div>
                        );
                      } else {
                        return (
                          <>
                            <span style={{ wordBreak: "keep-all" }}>
                              상담 희망일 :
                            </span>
                            <div
                              className={styles.mediaMargin}
                              style={{ marginLeft: "8px" }}
                            >
                              {wantWeddingData.map((item, idx) => (
                                <div key={idx} style={{ marginRight: "10px" }}>
                                  {moment(item.content).isValid() &&
                                  !!item.content
                                    ? moment(item.content).format("YYYY-MM-DD")
                                    : ""}

                                  {moment(item.content).isValid() &&
                                  !!item.content
                                    ? `(${moment(item.content).format("dd")})`
                                    : ""}
                                </div>
                              ))}
                            </div>
                          </>
                        );
                      }
                    } else if (item.status === 1) {
                      if (!!item.counsel_change_day) {
                        return (
                          <div style={{ color: redLightColor }}>
                            예약변경 확인중
                          </div>
                        );
                      } else {
                        return (
                          <div>
                            <div style={{ display: "flex" }}>
                              <div>상담 확정일 : </div>
                              <div>
                                <div
                                  style={{
                                    marginLeft: "10px",
                                    display: "flex",
                                  }}
                                  // className={styles.mediaMargin}
                                >
                                  {(!(item.counsel_days || "").includes("00") &&
                                    item.counsel_days) ||
                                    ""}
                                  {moment(item.counsel_days).isValid() &&
                                  !!item.counsel_days
                                    ? `(${moment(item.counsel_days).format(
                                        "dd"
                                      )})`
                                    : ""}
                                </div>
                              </div>
                            </div>
                            <div style={{ display: "flex" }}>
                              <div>상담 확정시간 : </div>
                              <div style={{ marginLeft: "10px" }}>
                                {item.counsel_time && item.counsel_time}
                              </div>
                            </div>
                            <div style={{ display: "flex" }}>
                              <div>예약변경/취소 잔여 :</div>
                              <div
                                style={{
                                  color: red,
                                  fontWeight: "600",
                                  marginLeft: "5px",
                                }}
                              >
                                {result}회
                              </div>
                            </div>
                          </div>
                        );
                      }
                    } else if (item.status === 2) {
                      const weddingDay = (
                        item.contract || {}
                      ).wedding_day?.split(" ")[0];
                      const weddingTime = (
                        item.contract || {}
                      ).wedding_day?.split(" ")[1];
                      return (
                        <div
                          style={{ display: "flex" }}
                          className={styles.mediaBlock}
                        >
                          <div style={{ lineHeight: "180%" }}>예식일 :</div>
                          <div
                            style={{ marginLeft: "10px" }}
                            className={styles.mediaMargin}
                          >
                            <span style={{ marginRight: "5px" }}>
                              {weddingDay || ""}
                            </span>
                            <span style={{ marginRight: "10px" }}>
                              {moment(weddingDay).isValid() && !!weddingDay
                                ? `(${moment(weddingDay).format("dd")})`
                                : ""}
                            </span>
                            <div>{weddingTime || ""}</div>
                          </div>
                        </div>
                      );
                    }
                    return <></>;
                  })()}
                </div>
              )}
            </div>
            {type === "etc" && (
              <div style={{ display: "flex" }}>
                {(() => {
                  if (item.status === 3 || !!item.counsel_cancel_day) {
                    if (item.status === 3) {
                      return (
                        <div style={{ color: "navy" }}> 예약 취소 완료</div>
                      );
                    }
                    if (item.status === 0) {
                      return (
                        <div style={{ color: "gray" }}> 접수 취소 완료</div>
                      );
                    } else {
                      return <div style={{ color: "orange" }}>취소 확인중</div>;
                    }
                  } else if (item.status === 0) {
                    if (!!item.counsel_cancel_reason) {
                      return (
                        <div style={{ color: "gray" }}> 접수 취소 완료</div>
                      );
                    } else {
                      return (
                        <>
                          <div style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px" }}>
                              {schedule.date}
                            </div>
                            <div>{schedule.time}</div>
                          </div>
                        </>
                      );
                    }
                  } else if (item.status === 1) {
                    //일정 변경할때
                    if (!!item.counsel_change_day) {
                      return (
                        <div style={{ color: redLightColor }}>
                          예약변경 확인중
                        </div>
                      );
                    } else {
                      return (
                        <>
                          <div style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px" }}>
                              {displayDate}
                            </div>
                            <div style={{ marginRight: "10px" }}>
                              {displayTime}
                            </div>
                            <div>{displayPoint}</div>
                          </div>
                        </>
                      );
                    }
                  } else if (item.status === 2) {
                    return (
                      <>
                        <div style={{ display: "flex" }}>
                          <div style={{ marginRight: "10px" }}>
                            {item.contract_day}
                          </div>
                        </div>
                      </>
                    );
                  } else {
                    return <></>;
                  }
                })()}
              </div>
            )}
          </div>
        </div>
      </div>
      <div onClick={(e) => e.stopPropagation()}>
        {(!!item.status ||
          (item.status === 0 &&
            !(!!item.counsel_cancel_reason && !!item.counsel_open_day))) &&
          statusButton({
            status: item.status,
            contructor_name: item.contructor_name,
            counsel_cancel_day: item.counsel_cancel_day,
          })}
      </div>
      {item.status === 1 && !item.counsel_cancel_day && (
        <img
          src="/images/right.png"
          alt="right"
          style={{ width: "20px", height: "20px", cursor: "pointer" }}
          onClick={() =>
            navigate(
              `/SignIn/InquiryBoxList/detail?no=${item.no}&type=${type}&status=${item.status}`
            )
          }
        />
      )}
    </div>
  );
}
